const getPopoverPosition = ({ event, tooltip }) => {
    const clientTarget = event.target;
    const clientRect = clientTarget.getBoundingClientRect();
    const tooltipRect = tooltip?.current.getBoundingClientRect();

    const popoverPositionCords = {
        left: clientRect.x + window?.scrollX + clientRect.width / 2,
        top: clientRect.y + window?.scrollY - tooltipRect?.height - 16,
    };

    return popoverPositionCords;
};

export { getPopoverPosition };
